module.exports = __webpack_public_path__ + "img/5a.9941ff60.svg";